// replay-pack.ts — add-on mission-pack mounting, shared by both replay viewers. A recording on
// a level that's not in the BASE art pack names its pack in the header (packId + md5 packHash —
// the same content-addressed identity the game's DLC flow downloads). Fetch it from the
// same-origin /wi-pack/ proxy (functions/wi-pack) and STACK it on the reader, exactly like the
// game mounts installed packs; the base pack still supplies art/tilesets. A fetch failure falls
// through to LevelDataFromPack's clear "not in pack" error.
import { MemPdbReader } from '../io/pdbreader.ts';
import type { PackFileReader } from '../io/packfile.ts';

export async function mountMissionPack(
  pakr: PackFileReader,
  header: { level: string; packId?: number; packHash?: string },
  setStatus: (s: string) => void,
  // where a content key `<id8hex>-<md5>` is fetched from — default: the viewer page's same-origin
  // /wi-pack/ proxy; the embedded game viewer passes its own content base (replay-player.ts).
  urlFor: (key: string) => string = (key) => `/wi-pack/${key}`,
): Promise<void> {
  if (pakr.MapFile(header.level) !== null || !header.packId || !header.packHash) return;
  setStatus('fetching mission pack…');
  const id8 = (header.packId >>> 0).toString(16).padStart(8, '0');
  try {
    const pr = await fetch(urlFor(`${id8}-${header.packHash}`));
    if (pr.ok) {
      const apdb = new MemPdbReader();
      if (apdb.Open(new Uint8Array(await pr.arrayBuffer()))) {
        pakr.Push(null, `${id8}.pdb`, apdb);
      }
    }
  } catch {
    /* offline content service → LevelDataFromPack's error names the level */
  }
}
